import { render, staticRenderFns } from "./client-concat.vue?vue&type=template&id=0637a768&scoped=true"
import script from "./client-concat.vue?vue&type=script&lang=js"
export * from "./client-concat.vue?vue&type=script&lang=js"
import style0 from "./client-concat.vue?vue&type=style&index=0&id=0637a768&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0637a768",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0637a768')) {
      api.createRecord('0637a768', component.options)
    } else {
      api.reload('0637a768', component.options)
    }
    module.hot.accept("./client-concat.vue?vue&type=template&id=0637a768&scoped=true", function () {
      api.rerender('0637a768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/home/client-concat.vue"
export default component.exports